import { render, staticRenderFns } from "./ActivixModal.vue?vue&type=template&id=f24724be&"
import script from "./ActivixModal.vue?vue&type=script&lang=js&"
export * from "./ActivixModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports